// extracted by mini-css-extract-plugin
module.exports =  {"Legend":"Legend__M66Gy","centered":"centered__GsnA3","itemName":"itemName__798gA","item":"item__93gm6","icon":"icon__j3G22","firstItem":"firstItem__z6T2g"};